/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

// actions
import { getAgent } from '../../actions/agent';

// components
import { Spinner } from '../../common/components';
import Profile from './user-details/Profile';


function StandaloneUserDetails() {
  const dispatch = useDispatch();
  const { username } = useParams();
  const [ loading, setLoading ] = useState(false);
  const [ user, setUser ] = useState({});

  useEffect(() => {
    setLoading(true);
    getAgent(username)
      .then(({ data }) => {
        dispatch({ type: 'SET_SELECTED_AGENT', agent: data });
        setUser(data);
      })
      .finally(() => setLoading(false));
  }, []);

  return !loading ? (
    <Profile user={user} />
  ) : (
    <Spinner />
  );
}

export default StandaloneUserDetails;
